// extracted by mini-css-extract-plugin
export default {"subtitle":"bP1DZXwh","editorial":"BNx90bcQ"};